import * as React from 'react';
import { Eye, CloseEye, msg_error, Open_eye_icon, lock_icon } from '../../utils/images';
import { cn } from '../../lib/utils';
import { Loader } from 'lucide-react';

const Input = React.forwardRef(
  ({ className, type, isWarningIcon, error, loading, isUserRegistration, ...props }, ref) => {
    const [isPasswordVisible, setPasswordVisible] = React.useState(false);
    const isPassword = type === 'password';
    return (
      <>
        <input
          type={isPassword ? (isPasswordVisible ? 'text' : 'password') : type === 'number' ? 'search' : type}
          className={cn('', className)}
          ref={ref}
          {...props}
          onChange={e => {
            if (props.name === 'email') {
              props.onChange(e.target.value.trim());
            } else {
              if (type === 'number') {
                // debugger
                if ((/^[0-9]+$/.test(e.target.value) || e.target.value === '') && e.target.value?.length < 7) {
                  props.onChange(e.target.value.trimStart());
                }
              } else {
                props.onChange(e.target.value.trimStart());
              }
            }
          }}
        />
        {isUserRegistration && (
          <span className="eye_pass">
            <img src={lock_icon} alt="lock icon" />
          </span>
        )}
        {isPassword && props?.value?.length > 0 && (
          <span className="eye_pass" onClick={() => setPasswordVisible(!isPasswordVisible)}>
            <img src={!isPasswordVisible ? CloseEye : Open_eye_icon} alt="eye" />
          </span>
        )}
        {isWarningIcon && error && (
          <div className="err_field">
            {
              <span className="error_icon">
                <img src={msg_error} alt="" />
              </span>
            }
            <div className="remove_tooltip">
              <span className="tooltip">{'Hello'}</span>
            </div>
          </div>
        )}
        {loading && (
          <div className="err_field">
            <span className="error_icon">
              <Loader className="animate-spin" />
            </span>
          </div>
        )}
      </>
    );
  }
);
Input.displayName = 'Input';

export { Input };
